<template>
	<div class="screen" :class="group ? 'bg-group' : 'bg-bg'">
		<slot />
	</div>
</template>

<script>
// Page wrapper: background plus room at the bottom for the tab bar, any Dock and the home indicator.
export default {
	props: {
		group: { type: Boolean, default: false },
	},
}
</script>
